export default __webpack_public_path__ + "static/media/maple.7926e2ad.jpg";